export const formatDate = (date: string | Date): string => {
    if (!date) {
        return "";
    }
    const dateObj = new Date(date);

    if (isNaN(dateObj.getTime())) {
        // console.error("Invalid Date:", date);
        return "";
    }

    const year = dateObj.getFullYear();
    let month = (dateObj.getMonth() + 1).toString();
    let day = dateObj.getDate().toString();

    return `${year}年${month}月${day}日`;
};

export const formatDateTime = (date: string | Date): string => {
    if (!date) {
      return "";
    }

    const dateObj = new Date(date);
    if (isNaN(dateObj.getTime())) {
        console.error("Invalid Date:", date);
        return "";
    }

    const year = dateObj.getFullYear();
    const month = (dateObj.getMonth() + 1).toString();
    const day = dateObj.getDate().toString();

    const hours = dateObj.getHours().toString().padStart(2, "0");
    const minutes = dateObj.getMinutes().toString().padStart(2, "0");

    return `${year}年${month}月${day}日 ${hours}:${minutes}`;
};

export const formatDateTimeExcludeYear = (date: string | Date): string => {
  const result = formatDateTime(date);
  return result.slice(5);
};

export const formatName = (firstName: string, lastName: string): string => {
    if(!firstName && !lastName) {
      return ''
    }
    return `${lastName} ${firstName}`;
};

export const formatYear = (date: string | Date): string => {
    if (!date) {
        return 'ー';
    }
    const dateObj = new Date(date);
    if (isNaN(dateObj.getTime())) {
        return 'ー';
    }
    const year = dateObj.getFullYear();
    return `${year}年`;
};

export const formatYearMonth = (date: string | Date): string => {
  if (!date) {
    return "";
  }
  const dateObj = new Date(date);
  if (isNaN(dateObj.getTime())) {
    return "";
  }
  const year = dateObj.getFullYear();
  const month = dateObj.getMonth() + 1;
  return `${year}年${month}月`;
};

export const getAge = (birthday: string | Date): string => {
    if (!birthday) {
        return 'ー';
    }

    const birthdayObj = new Date(birthday);
    if (isNaN(birthdayObj.getTime())) {
        return 'ー';
    }
    const today = new Date();
    let age = today.getFullYear() - birthdayObj.getFullYear();
    const monthDifference = today.getMonth() - birthdayObj.getMonth();

    // Check birthday
    if (
        monthDifference < 0 ||
        (monthDifference === 0 && today.getDate() < birthdayObj.getDate())
    ) {
        age--;
    }

    return `${age}歳`;
};

export const getAgeByYearMonthDay = (year: integer, month: integer, day: integer): string => {
  if (!year) {
      return 'ー';
  }

  const safeMonth = month || 1;
  const safeDay = day || 1;
  const birthdayObj = new Date(year, safeMonth - 1, safeDay);
  if (isNaN(birthdayObj.getTime())) {
      return 'ー';
  }
  const today = new Date();
  let age = today.getFullYear() - birthdayObj.getFullYear();
  const monthDifference = today.getMonth() - birthdayObj.getMonth();

  // Check birthday
  if (
      monthDifference < 0 ||
      (monthDifference === 0 && today.getDate() < birthdayObj.getDate())
  ) {
      age--;
  }

  return `${age}歳`;
};

export const dateToString = (date: string | Date) => {
    if (!date) return;
    
    date = new Date(date);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

export const formatTimeAgo = (date: string | Date): string => {
    const dateObj = new Date(date);

    if (isNaN(dateObj.getTime())) {
        console.error("Invalid Date:", date);
        return "";
    }

    const now = new Date();
    const diffInMillis = now.getTime() - dateObj.getTime();

    // Calculate time units
    const seconds = Math.floor(diffInMillis / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const weeks = Math.floor(days / 7);
    const months = Math.floor(days / 30);
    const years = Math.floor(days / 365);

    // Handle time differences in different periods
    if (years >= 1) {
        return `${years}年間前`;
    } else if (months >= 1) {
        return `${months}ケ月前`;
    } else if (weeks >= 1) {
        return `${weeks}週間前`;
    } else if (days >= 1) {
        return `${days}日前`;
    } else if (hours >= 1) {
        return `${hours}時間前`;
    } else if (minutes >= 1) {
        return `${minutes}分前`;
    } else {
        return `${seconds}秒前`;
    }
};

export const maxLengthText = (text: string, maxLength: number) => {
    var thisLength = text.length;
    if(thisLength > maxLength){
        text = text.substring(0, maxLength) + "...";
    }
    return text;
};
export const formatTime = (time: any, format: string = "HH:mm:ss") => {
    const timeParts = String(time).split(':');
    const timeObj = new Date(0, 0, 0, Number(timeParts[0]), Number(timeParts[1]), Number(timeParts[2]) || Number('00'));
    const hours = String(timeObj.getHours()).padStart(2, '0');
    const minutes = String(timeObj.getMinutes()).padStart(2, '0');
    const seconds = String(timeObj.getSeconds()).padStart(2, '0');
    if(format == "HH:mm"){
        return `${hours}:${minutes}`;
    }
    else if(format == "HH"){
        return `${hours}`;
    }
    else if(format == "mm"){
        return `${minutes}`;
    }
    else{
        return `${hours}:${minutes}:${seconds}`;
    }
};

export const formatChatSendTime = (date: string | Date): string => {
  const dateObj = new Date(date);
  if (isNaN(dateObj.getTime())) {
    console.error("Invalid Date:", date);
    return "";
  }
  const today = new Date();
  // const year = dateObj.getFullYear();
  // const month = (dateObj.getMonth() + 1).toString().padStart(2, "0");
  // const day = dateObj.getDate().toString().padStart(2, "0");
  const hours = dateObj.getHours().toString().padStart(2, "0");
  const minutes = dateObj.getMinutes().toString().padStart(2, "0");
  // if (year === today.getFullYear() &&
  //   dateObj.getMonth() === today.getMonth() &&
  //   dateObj.getDate() === today.getDate() ) {
  //   return `${hours}:${minutes}`;
  // } else {
  //   return `${month}月${day}日 ${hours}:${minutes}`;
  // }
  return `${hours}:${minutes}`;
};
export const formatChatConversationTime = (date: string | Date): string => {
  const dateObj = new Date(date);
  if (isNaN(dateObj.getTime())) {
    console.error("Invalid Date:", date);
    return "";
  }
  const today = new Date();
  const year = dateObj.getFullYear();
  const month = (dateObj.getMonth() + 1).toString();
  const day = dateObj.getDate().toString();
  const hours = dateObj.getHours().toString().padStart(2, "0");
  const minutes = dateObj.getMinutes().toString().padStart(2, "0");
  if (year === today.getFullYear() &&
    dateObj.getMonth() === today.getMonth() &&
    dateObj.getDate() === today.getDate() ) {
    return `${hours}:${minutes}`;
  } else {
    return `${month}月${day}日`;
  }
};
export const concat3String = (string1: string, string2: string, string3: string): string => {
  let result = ''
  if (string1) {
    result += string1
  } else {
    result += '-'
  }
  if (string2) {
    result += string2
  } else {
    result += '-'
  }
  if (string3) {
    result += string3
  } else {
    result += '-'
  }
  return result
};

export const concat2String = (string1: string|null, string2: string|null): string => {
  if (string1 && string2)
    return `${string1} - ${string2}`
  if (string1)
    return string1
  if (string2)
    return string2

  return ''
}

export const parseTags = (tagString: string) => {
    if (!tagString)
      return;
    
    const regex = /"([^"]*)"|([^",]+)/g;
    const tags = [];
    let match;

    while ((match = regex.exec(tagString)) !== null) {
        if (match[1]) {
            const tag = match[1].trim();
            if (tag) tags.push(tag);
        } else if (match[2]) {
            const tag = match[2].trim();
            if (tag) tags.push(tag);
        }
    }

    return tags;
  };

export const formatSttCustomerCompany = (is_contract_valid: boolean) => {
  let status = "非アクティブ";
  if(is_contract_valid) status = "アクティブ";
  return status;
}

export const formatFullInformation =  (date: string, type: string) => {
  if (!date) {
    return 'ー';
  }
  const dateObj = new Date(date);
  if (isNaN(dateObj.getTime())) {
    return 'ー';
  }
  const year = dateObj.getFullYear();
  const month = (dateObj.getMonth() + 1).toString();
  const day = dateObj.getDate().toString();
  let value = "";
  if (type == "birthday") value = `${year}/${month}/${day}`;
  if (type == "time") value = `${year}/${month}`;
  return value;
}

export const isInteger = (value: any) => {
  const parsedValue = parseInt(value, 10);
  return Number.isInteger(parsedValue) && parsedValue.toString() === value.trim();
}

export const clearHTMLTag = (text: any) => {
  const parseText = text.replace(/<[^>]*>/g, '');
  return parseText;
}

export const formatPadStartNumber = (numberInput: any, numberLength: number) => {
  return String(numberInput).padStart(numberLength, "0");
}

export const formatNewsTitle = (company_name: string, title: string) => {
  return company_name + "," + title;
}

//display number in 2 bytes width
export const toFullWidthNumber = (str: string) => {
  return str.replace(/[0-9]/g, (d) => String.fromCharCode(d.charCodeAt(0) + 0xFEE0));
}

export const formatDateForFileName = () => {
  const now = new Date();
  
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');

  return `${year}${month}${day}${hours}${minutes}`;
}

export const formatIdWithLength = (id: number, length: number = 6) => {
  return String(id).padStart(length, '0');
}

export const formatDisplayAllowedIP = (inputString: string) => {
  if(!inputString) return 'ー';
  
  const formattedArray  = inputString
    .split(',')
    .map(item => item.trim())
    .filter(item => item !== '');
  
  return formattedArray.join(',\n');
}

export const formatPercentageChange = (currentValue, previousValue, includeCurrentValue = true) => {
  const currentValueDisplay = includeCurrentValue ? `${currentValue}` : '';
  let percentageDisplay = '';
  if (previousValue !== 0) {
    const percentageChange = Math.ceil(currentValue / previousValue * 100);
    percentageDisplay = `${percentageChange}%`;
  } else if (currentValue !== 0) {
    percentageDisplay = 'ー';
  } else {
    percentageDisplay = '0%';
  }
  if (includeCurrentValue) {
    return `${currentValueDisplay}回/${percentageDisplay}`;
  } else {
    return percentageDisplay;
  }
};

import { marked } from 'marked';
import React from 'react';

export function getMarkdownExcerpt(markdown: string, maxLength: number = 100): string {
  if (!markdown) return "";

  const noUnderline = markdown.replace(/\+\+(.+?)\+\+/g, '$1');
  const html = marked(noUnderline);

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  const rawText = doc.body.textContent || '';

  let lines = rawText
    .split('\n')
    .filter(line => line.trim() !== '')
    .join('\n');

  if(lines.length > maxLength) {
    return lines.slice(0, maxLength) + "…";
  }

  return lines
}

export const formatJoinLeaveCompanyDate = (join_company_year: any, join_company_month: any, leave_company_year: any, leave_company_month: any): string => {
  let join_date = ''
  if (join_company_year) {
    join_date += join_company_year + "年"
    if (join_company_month) {
      join_date += join_company_month + "月"
    }
  }
  if(!join_date) {
    join_date = 'ー'
  }
  let leave_date = ''
  if (leave_company_year) {
    leave_date += leave_company_year + "年"
    if (leave_company_month) {
      leave_date += leave_company_month + "月"
    }
  }
  if(!leave_date) {
    leave_date = 'ー'
  }
  return `${join_date} 〜 ${leave_date}`;
};

export const convertToFullDate = (year: any, month: any, day: any, isAllowEmpty: boolean): string => {
  let result = ''
  if (year) {
    result += year + "年"
    if (month) {
      result += month + "月"
      if (day) {
        result += day + "日"
      }
    }
  }
  if(!result && !isAllowEmpty) {
    result = 'ー'
  }
  return result;
};

export const trimStringFields = <T extends Record<string, unknown>>(obj: T): T => {
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [
      key,
      typeof value === "string" ? value.trim() : value,
    ])
  ) as T;
};

export const getPeriodicTaskStatus = (taskStatus: any) => {
  if (taskStatus && taskStatus?.status === "EXPIRED") {
    return "公開予約の処理が失敗しました。\n日時を変更して再度公開予約の設定をしてください。";
  }
  return null;
};

const URL_TOKEN_REGEX = /(https?:\/\/[A-Za-z0-9\-._~:/?#[\]@!$&'()*+,;=%]+|www\.[A-Za-z0-9\-._~:/?#[\]@!$&'()*+,;=%]+)/g;
const URL_TRAILING_PUNCTUATION_REGEX = /([.,!?;:)\]}>'"\u2019\u201d]+)$/;

const splitUrlAndTrailingPunctuation = (value: string) => {
  const match = value.match(URL_TRAILING_PUNCTUATION_REGEX);

  if (!match) {
    return { url: value, trailingText: '' };
  }

  const trailingText = match[1];
  return {
    url: value.slice(0, -trailingText.length),
    trailingText,
  };
};

export const renderContentWithTrackedLinks = (text: string): (React.ReactNode)[] => {
  if (!text) {
    return [];
  }

  const parts: React.ReactNode[] = [];
  let lastIndex = 0;

  for (const match of text.matchAll(URL_TOKEN_REGEX)) {
    const rawMatch = match[0];
    const matchIndex = match.index ?? 0;

    if (matchIndex > lastIndex) {
      parts.push(text.slice(lastIndex, matchIndex));
    }

    const { url, trailingText } = splitUrlAndTrailingPunctuation(rawMatch);
    if (!url) {
      lastIndex = matchIndex + rawMatch.length;
      continue;
    }

    let fullUrl = url;
    if (fullUrl.startsWith('www.')) {
      fullUrl = `http://${fullUrl}`;
    }

    try {
      const urlObj = new URL(fullUrl);
      if (!urlObj.searchParams.has('utm_source') && !urlObj.searchParams.has('utm_medium')) {
        urlObj.searchParams.set('utm_source', 'aloop');
        urlObj.searchParams.set('utm_medium', 'referral');
      }

      const trackedHref = urlObj.toString();

      parts.push(
        React.createElement(
          'a',
          {
            key: `url-${matchIndex}`,
            href: trackedHref,
            target: '_blank',
            rel: 'noopener noreferrer',
            className: 'alu-text-base-2 underline underline-offset-2 break-all hover:text-[#FF861A]',
          },
          url
        )
      );
    } catch (error) {
      parts.push(url);
    }

    if (trailingText) {
      parts.push(trailingText);
    }

    lastIndex = matchIndex + rawMatch.length;
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return parts;
};

export const renderSafeMessage = (mes: any): React.ReactNode => {
  if (typeof mes !== 'string') return mes;

  const parts = mes.split(/<br\s*\/?>/gi);

  const elements = parts.map((part, index) =>
    React.createElement(
      React.Fragment,
      { key: `msg-part-${index}-${part.slice(0, 10)}` },
      part,
      index < parts.length - 1 ? React.createElement('br') : null
    )
  );

  return React.createElement(React.Fragment, null, ...elements);
};